import React, { Fragment, useContext, useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { UserContext } from "../UserContext";
import { hasAnyPerm } from '../utils/uiUtils';
import { useTranslation } from 'react-i18next';
import { axiosAuth_DATA_MGMT_API } from '../utils/AxoisUtilComponent';
import TemplateListView             from "./TemplateListView";
import CarparkSpaceAdminDetailsView from "./CarparkSpaceAdminDetailsView";
import CarparkSpaceAdminNewView     from "./CarparkSpaceAdminNewView";


const CarparkSpaceAdmin = () => {

  const { t }    = useTranslation(["common"]);
  const { user } = useContext(UserContext);
  const navigate = useNavigate();

  const [uiMode,     setUIMode]     = useState('LIST');
  const [objDetails, setObjDetails] = useState({});
  const [pageState,  setPageState]  = useState({
                                        searchTerms: null,
                                        sortCol:     null,
                                        sortDir:     null,
                                        perPage:     25,
                                        currPage:    1});

  // Initialize state
  useEffect(() => {

    // Route to home page if not authorized
    if (!hasAnyPerm(user, ["BuildingAdminGeneralWriteAccess"], true)) {
      navigate("/AdminHome/Dashboard", {
        state: {
          //...values
          target: 'Dashboard'
        }
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  // ----- Data Table stuff -----

  const tableColumns = [
    {
      igcColumnType: 'PRIMARY_ID',
      name: t("I18N_Code"),
      sortable: true,
      sortField: 'code',
      grow: 2.5,
      cell: null
    },
    {
      name: t("I18N_Description"),
      selector: row => row.description,
      grow: 2,
      wrap: true
    },
    {
      name: t("I18N_Display_code"),
      selector: row => row.displayCode,
      sortable: true,
      sortField: 'type',
    },
    {
      name: t("I18N_Type"),
      selector: row => t("common:I18N_" + row.type),
      sortable: true,
      sortField: 'type',
    },
    {
      name: t("I18N_Disabled_space"),
      selector: row => row.disabledSpace,
      sortable: true,
      sortField: 'disabledSpace',
      cell: row => (
        row.disabledSpace ? <span>&#10003;</span> : ''
      ),
    },
    {
      name: t("I18N_EV_charger"),
      selector: row => row.evCharger,
      sortable: true,
      sortField: 'evCharger',
      cell: row => (
        row.evCharger ? <span>&#10003;</span> : ''
      ),
    },
    {
      name: t("I18N_Floor_code"),
      selector: row => row.floorCode,
      sortable: true,
      sortField: 'floorCode',
    },
    {
      igcColumnType: 'DELETE',
      name: '',
      selector: row => row.id,
      grow: 0.5,
      cell: null
    }
  ];

  // ----- END - Data Table stuff -----

  const searchFieldOptions = [
    { key: "CODE",  value: "CODE" },
    { key: "DESCRIPTION", value: "DESCRIPTION" }
  ];


  return (
    <Fragment>

      {(uiMode === 'LIST')    ? <TemplateListView pageState={pageState}
                                                  axiosAPI={axiosAuth_DATA_MGMT_API}
                                                  apiObjName={'carpark-spaces'}
                                                  listPageTitle={t("I18N_CarparkSpace_Management")}
                                                  newObjTooltip={t("I18N_TIP_New_carpark_space")}
                                                  searchTooltip={t("I18N_Search")}
                                                  deleteConfirmDialogTitle={t("I18N_Carpark_space_delete_confirm")}
                                                  deleteObjTooltip={t("I18N_TIP_Delete_carpark_space")}
                                                  tableColumns={tableColumns}
                                                  primaryIdColType={'CODE'}
                                                  searchFieldOptions={searchFieldOptions}
                                                  deletePermission={'BuildingAdminGeneralDeleteAccess'}
                                                  onUIMode={setUIMode}
                                                  onSetPageState={setPageState}
                                                  onSetObjDetails={setObjDetails} /> : null}
      {(uiMode === 'DETAILS') ? <CarparkSpaceAdminDetailsView onUIMode={setUIMode} objDetails={objDetails} />                  : null}
      {(uiMode === 'NEW')     ? <CarparkSpaceAdminNewView     onUIMode={setUIMode} />                                          : null}

    </Fragment>
  )
}

export default CarparkSpaceAdmin;
